export enum TipoContaPixEnum {
    CONTA_PAGAMENTO = 1,
    CONTA_CORRENTE = 2,
    CONTA_POUPANCA = 3
}
